/* eslint-disable import/no-extraneous-dependencies */
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as shippingInfoActionsForFunctional from '../actions';
import injectReducer from '../../../utils/injectReducer';
import injectSaga from '../../../utils/injectSaga';
import saga from '../sagas';
import shippingInfo from '../reducer';
import ShippingHeader from '../../../components/Web/ShippingInfo/shippingHeader';

const mapStateToProps = (state) => {
  const shippingInfoState = state.shippingInfo;
  return {
    shippingInfoState,
  };
};
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...shippingInfoActionsForFunctional }, dispatch);
}
const withReducer = compose(injectReducer({ key: 'shippingInfo', reducer: shippingInfo }));

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

const withSaga = injectSaga({ key: 'shippingInfo', saga });
export default withRouter(
  compose(
    withSaga,
    withReducer,
    withConnect,
  )(ShippingHeader),
);
